import { useAuthenticatedFetch } from "./useAuthenticatedFetch.js"

export const useSetSelectedStore = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId, store) => {
		return await authenticatedFetch("/api/firestore/setSelectedStore", {
			method: "POST",
			body: JSON.stringify({
				userId,
				store,
			}),
		}).catch((err) => console.error(err))
	}
}

export const useGetUserStores = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId) => {
		return await authenticatedFetch(
			`/api/firestore/getUserStores?userId=${userId}`,
		)
			.then((res) => res.json())
			.then((json) => {
				return {
					stores: json?.stores || {},
					selectedStore: json?.selectedStore || null,
					hasCompletedOnBoarding:
						json?.hasCompletedOnBoarding || false,
					staffForStores: json?.staffForStores || [],
					storeOwners: json?.storeOwners || {},
					savedStores: json?.savedStores || [],
				}
			})
			.catch((err) => {
				console.error(err)
				return {
					stores: {},
					selectedStore: null,
					hasCompletedOnBoarding: false,
					staffForStores: [],
					storeOwners: {},
					savedStores: [],
				}
			})
	}
}

export const useUpdateUser = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId, fields) => {
		return await authenticatedFetch("/api/firestore/updateUser", {
			method: "POST",
			body: JSON.stringify({
				userId,
				fields,
			}),
		})
			.then((res) => res.json())
			.then((json) => {
				return {
					success: json?.success || false,
					error: json?.error || null,
				}
			})
			.catch((err) => console.error(err))
	}
}

export const useGetDelegations = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId) => {
		return await authenticatedFetch(
			`/api/firestore/getDelegations?userId=${userId}`,
		)
			.then((res) => res.json())
			.then((json) => {
				return json?.delegations || {}
			})
			.catch((err) => {
				console.error(err)
				return {}
			})
	}
}

export const useAddDelegation = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId, delegateEmail, delegatedStores) => {
		return await authenticatedFetch("/api/firestore/addDelegation", {
			method: "POST",
			body: JSON.stringify({
				userId,
				delegateEmail,
				delegatedStores,
			}),
		})
			.then((res) => res.json())
			.then((json) => {
				return {
					success: json?.success || false,
					errorCode: json?.errorCode || null,
				}
			})
			.catch((err) => {
				console.error(err)
				return {
					success: false,
					errorCode: null,
				}
			})
	}
}

export const useDeleteDelegation = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId, staffId) => {
		return await authenticatedFetch("/api/firestore/deleteDelegation", {
			method: "POST",
			body: JSON.stringify({
				userId,
				staffId,
			}),
		}).catch((err) => {
			console.error(err)
		})
	}
}

export const useCheckIfEmailIsRegistered = (email) => {
	return async (email) => {
		return await fetch(
			`/api/firestore/checkIfEmailIsRegistered?email=${email}`,
		)
			.then((res) => res.json())
			.then((json) => {
				return {
					emailIsRegistered: json?.emailIsRegistered || false,
				}
			})
			.catch((err) => {
				console.error(err)
				return {
					emailIsRegistered: false,
				}
			})
	}
}

export const useSaveStore = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId, store) => {
		return await authenticatedFetch("/api/firestore/saveStore", {
			method: "POST",
			body: JSON.stringify({
				userId,
				store,
			}),
		})
			.then((res) => res.json())
			.then((json) => {
				return {
					success: json?.success || false,
					errorCode: json?.errorCode || null,
					censoredEmail: json?.censoredEmail || null,
				}
			})
			.catch((err) => {
				console.error(err)
				return {
					success: false,
					errorCode: null,
					censoredEmail: null,
				}
			})
	}
}

export const useRemoveSavedStore = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId, store) => {
		return await authenticatedFetch("/api/firestore/removeSavedStore", {
			method: "POST",
			body: JSON.stringify({
				userId,
				store,
			}),
		})
			.then((res) => res.json())
			.then((json) => {
				return {
					success: json?.success || false,
					error: json?.error || null,
				}
			})
			.catch((err) => console.error(err))
	}
}

export const useChangeDefaultTranslateLanguage = () => {
	const authenticatedFetch = useAuthenticatedFetch()
	return async (userId, store, lang) => {
		return await authenticatedFetch(
			"/api/firestore/changeDefaultTranslateLanguage",
			{
				method: "POST",
				body: JSON.stringify({
					userId,
					store,
					lang,
				}),
			},
		).catch((err) => console.error(err))
	}
}
